









import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
@Component
export default class VariableHidden extends Vue {
  @Prop() private name!: string;
  @Prop() private value?: string;
  @Prop({default: false}) private readonly?: boolean;
  @Prop({default: false}) private disabled?: boolean;
}
